import { create } from 'zustand';
import { usePrismItemStore } from 'stores/usePrismItemStore';

export const useAllSlotsStore = create((set, get) => ({
  totalSlots: null,
  isLoading: true,
  error: null,

  updateTotalSlots: async () => {
    try {
      set({ isLoading: true, error: null });
      const store = usePrismItemStore.getState();
      const totalSlots = await store.totalNumberPhotoSlots();
      set({ totalSlots, isLoading: false });
      return totalSlots;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  resetTotalSlots: () => set({ totalSlots: null, error: null, isLoading: true }),

  // Subscribe to changes in PrismItemStore's total slots
  subscribeToChanges: () => {
    // Initial fetch
    get().updateTotalSlots();

    // Subscribe to PrismItem changes
    return usePrismItemStore.subscribe(
      async () => {
        // Get the latest total slots whenever PrismItem changes
        await get().updateTotalSlots();
      }
    );
  }
})); 